import { find } from 'lodash';
function findEnumDisplayName() {
  var enumArr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments.length > 1 ? arguments[1] : undefined;
  return (find(enumArr, {
    value: value
  }) || {}).display_name;
}
export default findEnumDisplayName;
//# sourceMappingURL=findEnumDisplayName.js.map